const app = angular.module('msi.shipments.sendShipmentNow', [
  require('./send-shipment-now.controller')
]);

app.component('ogSendShipmentNowButton', require('./send-shipment-now-button'));

module.exports = app.name;
